import AppLayout from '../../../components/AppLayout';
import { S, Icon } from '../../regureStyles';
import AccessLog from './AccessLog';
import ActionMessage from './ActionMessage';
import Actions from './Actions';
import DocumentInfo from './DocumentInfo';
import Header from './Header';
import SignerProgress from './SignerProgress';
import useSignDetailFunctions from './useSignDetailFunctions';

const ESignatureDetailScreen = () => {
  const { history, request, loading, error, reminding, cancelling, downloading, actionMsg, handleRemind, handleCancel, handleDownload, resealing, handleReseal, ConfirmPortal } = useSignDetailFunctions();

  const card = (title, children) => (
    <div style={{ background: '#fff', border: `1px solid ${S.borderLight}`, borderRadius: 16, padding: 24, marginBottom: 20 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: S.textPrimary, marginBottom: 16, textTransform: 'uppercase', letterSpacing: 0.8 }}>{title}</div>
      {children}
    </div>
  );

  return (
    <AppLayout>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflowY: 'auto' }}>
        {/* Header */}
        <Header history={history} request={request} loading={loading} />

        <div style={{ flex: 1, padding: '24px 32px', maxWidth: 900 }}>
          {loading ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              {[200, 280, 180].map((h, i) => (
                <div key={i} style={{ height: h, background: S.bgCard, borderRadius: 16, border: `1px solid ${S.borderLight}` }} />
              ))}
            </div>
          ) : error ? (
            <div style={{ textAlign: 'center', padding: 48 }}>
              <Icon name='alert-circle' color={S.danger} size={32} />
              <div style={{ marginTop: 12, color: S.danger, fontWeight: 600 }}>{error}</div>
            </div>
          ) : request ? (
            <>
              {actionMsg && <ActionMessage actionMsg={actionMsg} />}

              {/* Document info */}
              <DocumentInfo request={request} />

              {/* Signer progress */}
              <SignerProgress request={request} />

              {/* Actions */}
              <Actions
                request={request}
                handleDownload={handleDownload}
                downloading={downloading}
                handleRemind={handleRemind}
                reminding={reminding}
                handleCancel={handleCancel}
                cancelling={cancelling}
                handleReseal={handleReseal}
                resealing={resealing}
              />

              {/* Access log */}
              <AccessLog request={request} />
            </>
          ) : null}
        </div>
      </div>
      {ConfirmPortal}
    </AppLayout>
  );
};

export default ESignatureDetailScreen;
